import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Status } from "../../../common/constants";
import { listSinglewireSiteUrl } from "../../../config";
import { RootState } from "../../../store";
import api from "../../../api";
import {
  ISinglewireSiteApi,
  ISinglewireSites,
} from "../../../common/types/singlewireTypes";
import { getCookie } from "../../../common/utils";

export const GET_SINGLEWIRESITE: string = "getSinglewireSite";

const initialState: ISinglewireSiteApi = {
  singlewireSite: null,
  status: Status.IDLE,
  msg: null,
  error: null,
};

export const fetchSinglewireSiteData = createAsyncThunk(
  GET_SINGLEWIRESITE,
  async (_, { rejectWithValue }) => {
    try {
      const emailId: string = decodeURIComponent(getCookie("email"));
      const response = await api.get(
        `${listSinglewireSiteUrl}email=${emailId}`,
      );
      const singlewireSiteData: ISinglewireSites = response.data;
      return singlewireSiteData;
    } catch (error) {
      throw rejectWithValue(error);
    }
  },
);

const listSinglewireSiteSlice = createSlice({
  name: GET_SINGLEWIRESITE,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSinglewireSiteData.pending, (state) => {
        state.status = Status.PENDING;
      })
      .addCase(fetchSinglewireSiteData.fulfilled, (state, action) => {
        state.status = Status.SUCCESS;
        state.singlewireSite = action.payload;
      })
      .addCase(fetchSinglewireSiteData.rejected, (state, action) => {
        const errorPayload = action.payload as {
          response?: {
            data?: { error?: { message?: string }; message?: string };
          };
        };
        state.msg =
          errorPayload.response?.data?.error?.message ||
          errorPayload.response?.data?.message ||
          "Unknown error occurred";
        state.status = Status.FAILED;
        state.error = action.error.message || null;
      });
  },
});

export const selector = (state: RootState) => state.singlewireSiteApi;

export const reducer = listSinglewireSiteSlice.reducer;
